import { SelectedFields, SkuTier } from "./types";

/**
 * 選択されたフィールドから必要なSKUティアを計算
 */
export function calculateRequiredTiers(selectedFields: SelectedFields): SkuTier[] {
  const tiers: SkuTier[] = [];

  // Essentials tier
  if (
    selectedFields.name ||
    selectedFields.formattedAddress ||
    selectedFields.addressComponents ||
    selectedFields.location ||
    selectedFields.googleMapsUri
  ) {
    tiers.push("basic");
  }

  // Contact tier
  if (selectedFields.internationalPhoneNumber || selectedFields.websiteUri) {
    tiers.push("contact");
  }

  // Atmosphere tier
  if (
    selectedFields.rating ||
    selectedFields.userRatingCount ||
    selectedFields.businessStatus ||
    selectedFields.regularOpeningHours ||
    selectedFields.parkingOptions
  ) {
    tiers.push("atmosphere");
  }

  return tiers;
}

/**
 * SKUティアからコストを概算（ドル）
 */
export function estimateCostUsd(tiers: SkuTier[]): number {
  const tierCosts: Record<SkuTier, number> = {
    basic: 0.005, // $0.005/件
    contact: 0.017, // $0.017/件
    atmosphere: 0.025 // $0.025/件
  };

  return tiers.reduce((sum, tier) => sum + (tierCosts[tier] || 0), 0);
}

/**
 * SKUティアの表示名
 */
export function getSkuTierDisplayName(tier: SkuTier): string {
  const names: Record<SkuTier, string> = {
    basic: "Essentials",
    contact: "Contact",
    atmosphere: "Atmosphere"
  };
  return names[tier];
}

/**
 * 国際形式の電話番号を日本国内形式に変換
 * 例: "+81 90-1234-5678" → "090-1234-5678"
 */
export function convertToLocalPhoneNumber(internationalNumber: string | null | undefined): string {
  if (!internationalNumber) return "";

  // Only convert Japanese international numbers
  if (internationalNumber.startsWith("+81")) {
    return internationalNumber
      .replace(/^\+81\s*/, "0") // "+81 " または "+81" を "0" に置換
      .replace(/\s/g, ""); // スペースを削除
  }

  // For non-Japanese or already local format, just remove spaces
  return internationalNumber.replace(/\s/g, "");
}
